import { createSlice } from '@reduxjs/toolkit'
import { setUserAttributes } from '../../analytics'

const initialState = {
  sendOtp: {
    loading: false,
    error: null,
    data: null,
  },
  verifyOtp: {
    loading: false,
    error: null,
    data: null,
  },
  updateProfile: {
    loading: false,
    error: null,
    data: null,
  },
  patientDetails: {
    loading: false,
    error: null,
    data: null,
  },
  registerPatient: {
    loading: false,
    error: null,
    data: null,
  },
  updatePatientInfoState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  asignGLPPlanState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  saveDoctorDetailsState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    sendOtpRequest: (state, action) => {
      state.sendOtp.loading = true
      state.sendOtp.error = null
      state.sendOtp.data = null
    },
    sendOtpSuccess: (state, action) => {
      state.sendOtp.loading = false
      state.sendOtp.error = null
      state.sendOtp.data = action.payload
    },
    sendOtpError: (state, action) => {
      state.sendOtp.loading = false
      state.sendOtp.data = null
      state.sendOtp.error = action.payload
    },

    verifyOtpRequest: (state, action) => {
      state.verifyOtp.loading = true
      state.verifyOtp.error = null
      state.verifyOtp.data = null
    },
    verifyOtpSuccess: (state, action) => {
      state.verifyOtp.loading = false
      state.verifyOtp.error = null
      state.verifyOtp.data = action.payload
      setUserAttributes(action.payload?.data)
    },
    verifyOtpError: (state, action) => {
      state.verifyOtp.loading = false
      state.verifyOtp.data = null
      state.verifyOtp.error = action.payload
    },

    updateProfileRequest: (state, action) => {
      state.updateProfile.loading = true
      state.updateProfile.error = null
      state.updateProfile.data = null
    },
    updateProfileSuccess: (state, action) => {
      state.updateProfile.loading = false
      state.updateProfile.error = null
      state.updateProfile.data = action.payload
    },
    updateProfileError: (state, action) => {
      state.updateProfile.loading = false
      state.updateProfile.data = null
      state.updateProfile.error = action.payload
    },

    getPatientDetailsRequest: (state, action) => {
      state.patientDetails.loading = true
      state.patientDetails.error = null
      state.patientDetails.data = null
    },
    getPatientDetailsSuccess: (state, action) => {
      state.patientDetails.loading = false
      state.patientDetails.error = null
      state.patientDetails.data = action.payload
      setUserAttributes(action.payload)
    },
    getPatientDetailsError: (state, action) => {
      state.patientDetails.loading = false
      state.patientDetails.data = null
      state.patientDetails.error = action.payload
    },

    registerPatientRequest: (state, action) => {
      state.registerPatient.loading = true
      state.registerPatient.error = null
      state.registerPatient.data = null
    },
    registerPatientSuccess: (state, action) => {
      state.registerPatient.loading = false
      state.registerPatient.error = null
      state.registerPatient.data = action.payload
    },
    registerPatientError: (state, action) => {
      state.registerPatient.loading = false
      state.registerPatient.data = null
      state.registerPatient.error = action.payload
    },

    updatePatientDetailsToken: (state, action) => {
      if (!state.patientDetails.data) {
        state.patientDetails.data = {}
      }
      state.patientDetails.data.token = action.payload
    },

    updatePatientInformationRequest: (state, action) => {
      state.updatePatientInfoState = {
        ...state.updatePatientInfoState,
        loading: true,
        error: null,
        success: false,
        data: null,
      }
    },
    updatePatientInformationSuccess: (state, action) => {
      state.updatePatientInfoState = {
        ...state.updatePatientInfoState,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      }
    },
    updatePatientInformationError: (state, action) => {
      state.updatePatientInfoState = {
        ...state.updatePatientInfoState,
        loading: false,
        data: null,
        success: false,
        error: action.payload,
      }
    },
    resetUpdatePatientInfoState: (state) => {
      state.updatePatientInfoState = {
        ...state.updatePatientInfoState,
        loading: false,
        success: false,
        error: null,
        data: null,
      }
    },

    // Assign GLP Plan API call
    asignGLPPlanRequest: (state, action) => {
      state.asignGLPPlanState = {
        ...state.asignGLPPlanState,
        loading: true,
        error: null,
        success: false,
        data: null,
      }
    },
    asignGLPPlanSuccess: (state, action) => {
      state.asignGLPPlanState = {
        ...state.asignGLPPlanState,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      }
    },
    asignGLPPlanError: (state, action) => {
      state.asignGLPPlanState = {
        ...state.asignGLPPlanState,
        loading: false,
        data: null,
        success: false,
        error: action.payload,
      }
    },
    saveDoctorDetailsRequest: (state, action) => {
      state.saveDoctorDetailsState = {
        ...state.saveDoctorDetailsState,
        loading: true,
        error: null,
        success: false,
        data: null,
      }
    },
    saveDoctorDetailsSuccess: (state, action) => {
      state.saveDoctorDetailsState = {
        ...state.saveDoctorDetailsState,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      }
    },
    saveDoctorDetailsError: (state, action) => {
      state.saveDoctorDetailsState = {
        ...state.saveDoctorDetailsState,
        loading: false,
        data: null,
        success: false,
        error: action.payload,
      }
    },
  },
})

export const {
  sendOtpRequest,
  sendOtpSuccess,
  sendOtpError,

  verifyOtpRequest,
  verifyOtpSuccess,
  verifyOtpError,

  updateProfileRequest,
  updateProfileSuccess,
  updateProfileError,

  getPatientDetailsRequest,
  getPatientDetailsSuccess,
  getPatientDetailsError,

  registerPatientRequest,
  registerPatientSuccess,
  registerPatientError,

  updatePatientDetailsToken,

  updatePatientInformationRequest,
  updatePatientInformationSuccess,
  updatePatientInformationError,
  resetUpdatePatientInfoState,

  asignGLPPlanRequest,
  asignGLPPlanSuccess,
  asignGLPPlanError,

  saveDoctorDetailsRequest,
  saveDoctorDetailsSuccess,
  saveDoctorDetailsError,
} = authSlice.actions

export default authSlice.reducer
